import { connect } from 'react-redux'
import { replace } from 'react-router-redux'
import at from 'lodash/at'
import get from 'lodash/get'

import { loadServicingsForWorkOrder } from '../../actions/servicings'

import WorkSummaryWorkOrderTabsPendingApproval from '../../components/work-summaries/work-summary-work-order-tabs-pending-approval'

const tabNames = [
  'areas',
  'comments',
  'messages',
]

function mapStateToProps (state, ownProps) {
  const workOrderId = ownProps.workOrderId

  const workOrder = state.workOrders[workOrderId]

  const pagination = get(state, `pagination.servicingsByWorkOrder.${workOrderId}-finished`, {})
  const finishedServicings = at(state.servicings, pagination.ids || [])

  const selectedTab = tabNames.indexOf(ownProps.location.query.tab)

  return {
    workOrder,
    workOrderId,
    servicings: finishedServicings,
    hasNextPage: pagination.nextPageUrl,

    selectedTab,

    loadingServicings: state.servicings.loading || false
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const id = ownProps.workOrderId

  dispatch(loadServicingsForWorkOrder(id, 'finished'))

  return {
    onTabSelect (tabIndex) {
      dispatch(replace({
        pathname: ownProps.location.pathname,
        query: {
          ...ownProps.location.query,
          tab: tabNames[tabIndex]
        }
      }))
    },

    onLoadNextPage () {
      dispatch(loadServicingsForWorkOrder(id, 'finished', true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkSummaryWorkOrderTabsPendingApproval)



// WEBPACK FOOTER //
// ./src/containers/work-summaries/work-summary-work-order-tabs-pending-approval-container.js